import api, { unwrap } from './client';

export async function summary() {
  return unwrap(await api.get('/admin/dashboard/summary'));
}

export async function revenue(params = {}) {
  return unwrap(await api.get('/admin/reports/revenue', { params }));
}

export async function packagesReport(params = {}) {
  return unwrap(await api.get('/admin/reports/packages', { params }));
}

export async function vendorsReport(params = {}) {
  return unwrap(await api.get('/admin/reports/vendors', { params }));
}

export async function usersReport(params = {}) {
  return unwrap(await api.get('/admin/reports/users', { params }));
}
